import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { EMBER_ROUTE_NAMES } from 'sh-www/constants/routes';
import { BUYER_SIGNUP_STEPS } from 'sh-www/constants/buyer-signup-step';

const getBuyerSignupStepRoute = {
  [BUYER_SIGNUP_STEPS.EMAIL_PASSWORD]: EMBER_ROUTE_NAMES.BRAND__SIGNUP,
  [BUYER_SIGNUP_STEPS.COMPANY_INFO_STEP]: EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP__COMPANY_INFO,
  [BUYER_SIGNUP_STEPS.ABOUT_YOU_STEP]: EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP__ABOUT_YOU,
  [BUYER_SIGNUP_STEPS.PAYMENT_METHOD_STEP]: EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP__PAYMENT_METHOD,
  [BUYER_SIGNUP_STEPS.VERIFY_EMAIL_STEP]: EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP__VERIFY_EMAIL,
  [BUYER_SIGNUP_STEPS.COMPANY_PENDING_APPROVAL_STEP]: EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP__PENDING_APPROVAL,
  [BUYER_SIGNUP_STEPS.ADMIN_APPROVAL_STEP]: EMBER_ROUTE_NAMES.BRAND__SIGNUP__STEP__PENDING_APPROVAL,
};

class BrandSignupStepRoute extends Route {
  @service('commands/user-commands')
  userCommandService;

  @service router;
  @service session;

  beforeModel() {
    if (!this.session.currentUser?.isBuyer) {
      this.router.replaceWith('start');
    }
  }

  model() {
    const { signupFunnel, signupStep } = this.session.currentUser;

    return {
      step: signupStep,
      flow: signupFunnel,
    };
  }

  afterModel({ step }) {
    if (!step) {
      throw new Error('No step available in buyer funnel');
    }
  }

  /** @inheritDoc */
  redirect({ step }, transition) {
    if (step === 'done') {
      this.router.transitionTo(EMBER_ROUTE_NAMES.START);
      return;
    }

    const stepRoute = getBuyerSignupStepRoute[step];

    if (transition.to.name !== stepRoute) {
      this.router.transitionTo(stepRoute);
    }
  }
}

export default BrandSignupStepRoute;
